export enum ProductActionTypes {
    SET_PRODUCTS = 'SET_PRODUCTS',
    SET_LOADING = 'SET_LOADING',
    LOAD_PRODUCTS = 'LOAD_PRODUCTS',
}